import React from 'react';
import { getCustomer } from '../../../../../helpers/customer-helper';
import { projectCreate } from '../../../../../helpers/project-helper';

const getTodayDate = () => new Date().toISOString().slice(0, 10);

export const useProjectCreateForm = ({ token, navigate }) => {
    const [isSaving, setIsSaving] = React.useState(false);
    const [isLoadingCustomers, setIsLoadingCustomers] = React.useState(true);
    const [error, setError] = React.useState('');
    const [customers, setCustomers] = React.useState([]);
    const [form, setForm] = React.useState({
        customer: '',
        name: '',
        startDate: getTodayDate(),
        endDate: '',
        status: 'ACTIVE',
    });

    React.useEffect(() => {
        const fetchCustomers = async () => {
            if (!token) {
                setIsLoadingCustomers(false);
                return;
            }

            setIsLoadingCustomers(true);
            const resp = await getCustomer(token, {
                limit: 100,
                offset: 0,
                status: 'ACTIVE',
            });

            if (!resp?.success) {
                setError(resp?.message || 'No se pudieron cargar los clientes.');
                setCustomers([]);
                setIsLoadingCustomers(false);
                return;
            }

            const rows = Array.isArray(resp.data) ? resp.data : [];
            setCustomers(rows);
            setForm((previous) => ({
                ...previous,
                customer: previous.customer || rows[0]?._id || '',
            }));
            setIsLoadingCustomers(false);
        };

        fetchCustomers();
    }, [token]);

    const handleInputChange = React.useCallback((event) => {
        const { name, value } = event.target;
        setForm((previous) => ({
            ...previous,
            [name]: value,
        }));
    }, []);

    const handleSubmit = React.useCallback(async (event) => {
        event.preventDefault();

        if (!token || isSaving) {
            return;
        }

        setIsSaving(true);
        setError('');

        const payload = {
            customer: form.customer,
            name: form.name.trim(),
            startDate: form.startDate || undefined,
            endDate: form.endDate || undefined,
            status: form.status,
        };

        const resp = await projectCreate(token, payload);

        if (!resp?.success) {
            setError(resp?.message || 'No se pudo crear el proyecto.');
            setIsSaving(false);
            return;
        }

        const projectId = resp?.data?._id;
        if (projectId) {
            navigate(`/project/detail/${projectId}`, {
                state: {
                    projectName: resp?.data?.name,
                },
            });
            return;
        }

        navigate('/project/list');
    }, [token, isSaving, form, navigate]);

    const handleCancel = React.useCallback(() => {
        navigate('/project/list');
    }, [navigate]);

    return {
        isSaving,
        isLoadingCustomers,
        error,
        customers,
        form,
        handleInputChange,
        handleSubmit,
        handleCancel,
    };
};
